import { TableColumnVisibilityController, TableColumnGroup } from "../../../shared/scripts/table-column-visibility";
import { DataTableProjectForm } from "./project-form.entities";

export class ProjectFormDataTable {
    dataTable: any;
    data: DataTableProjectForm[];
    tableColumnController: TableColumnVisibilityController;

    constructor(entries: DataTableProjectForm[]) {
        $(() => {
            this.data = entries;
            this.initializeTable();
        });
    }
    initializeTable(): void {

        let columns: any[] = [
            { data: "DisplayId", title: "ID", className: "formId text-left font-size12 nowrap"},
            { data: "DisplayName", title: "Submitter", className: "submitter text-left font-size12 nowrap" },
            { data: "DisplayStatus", title: "Status", className: "status text-left font-size12 nowrap" },
            { data: "SubmissionDate", title: "Submission Date", className: "submissionDate text-left font-size12 nowrap" },
            { data: "RevisionDate", title: "Most Recent Revision Date", className: "revisionDate text-left font-size12 nowrap" },
            { data: "LeadHub", title: "Lead Hub", className: "hub text-left font-size12 nowrap" },
            { data: "Button", title: "", className: "hub text-left font-size12 nowrap" },

        ];


        this.dataTable = $('#project-form-table').DataTable({
            "dom": '<"top-controls"<"column-select"><"spacer"><"count-found"B><"search-bar"f>>rtip',
            autoWidth: true,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '70vh',
            scrollCollapse: true,
            orderCellsTop: true,
            fixedColumns: {
                leftColumns: 1
            },
            columns: columns,
            buttons: [
                //{
                //    extend: 'csv',
                //    text: '<i class="fas fa-file-download"></i>',
                //    titleAttr: 'CSV',
                //    charset: 'utf-8',
                //    //exportOptions: {
                //    //    columns: [1, 2, 3, 4]
                //    //}
                //},
            ],
            data: this.data,
        });
        $(".top-controls").addClass('row mx-0');

        $(".column-select").addClass('col-12 col-md-3 px-0');
        $(".column-select").empty().html('<div id="column-select" class="truncated-select"></div>');
        $(".collapse-filters").empty().html('<button type="button" class="btn btn-sm btn-outline-secondary font-size11 collapse-button" id="collapse-button" onclick="page.toggleExpertiseSidebar()"><i class="fa-solid fa-arrow-left" id="arrow"></i></button>');

        $(".search-bar").addClass('col-12 col-md-3 px-0');

        $(".count-found").addClass('col-12 col-md-6 d-flex justify-content-end vertical-align-middle align-self-end pr-0 mt-0');
        //<span id="people-found-count" class="font-italic font-size12" > </span>
        $(".count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"><span id=\"people-found-count\"></span></div>');
        $(".count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"></div>');

        //this.tableColumnController = new TableColumnVisibilityController('#user-directory-table', '#column-select', [
        //    new TableColumnGroup("Email", true, [], "email"),
        //    new TableColumnGroup("Name", false, [], "name"),
        //]);

        //$('#user-directory-table').on('search.dt', (e, settings) => {
        //    this.setCountFoundLabel(this.dataTable.rows({ search: 'applied' }).count());
        //});
        //this.setCountFoundLabel(this.data.length);
    }
}